import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-valuation-request',
  templateUrl: './modal-valuation-request.component.html',
  styleUrls: ['./modal-valuation-request.component.scss']
})
export class ModalValuationRequestComponent {
  options = ['',''];
}
